import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./App";
import "./index.css";

// vite-react-ssg wraps the tree in HelmetProvider itself (both at build time
// and on the client), so react-helmet-async's <Helmet> usage elsewhere in the
// app (Seo.tsx, Layout.tsx) needs no provider set up here.
//
// StrictMode is intentionally dropped here rather than carried over — it's a
// dev-only double-invoke check, and this codebase has no known effect-cleanup
// bug it was catching. Re-add by wrapping <Layout /> in Task 2 Step 2's
// `element` if that changes.
export const createRoot = ViteReactSSG({ routes });
